/* Custom pure event delegation & .closest() functions.*/
EventTarget.prototype.delegateListener=function(b,c,d){let a=a=>{let b;[].slice.call(this.querySelectorAll(c)).reverse().filter(b=>b.contains(a.target)).forEach(c=>{(void 0===b|| !1!==b)&&(b=d.call(c,a))})};return this.addEventListener(b,a),a};function closest(a,b){do if(b(a))return a;while(a=a&&a.parentNode)}

window.Custom = window.Custom || {};

(function ($) {
  "use strict";

Custom = {
  container: document.querySelector(`[data-section="body"]`),

  mobileBreakpoint: "868px",

  init: function() {
    // BASE
    this.setElementHeight();
    this.fontSize();
    this.setScrollAttributes();
    this.initImageSizeLogging();

    this.setCheckoutUtm();
    this.saveUtmParams('[data-utm]');

    this.accountPopup();
    this.localizationPopup();
    
    this.initContentTabs();
    this.initFeaturedProductsSection();
    this.initTimer();

    if(document.querySelector('.shopify_subscriptions_app_block_label') && JSON.parse(document.querySelector("[data-sub-details]").dataset.subDetails) !== null) {
      this.initProductSubscriptionCustom();
    }

    // document.querySelector(".cart__checkout-button").addEventListener("click", async (e) => {
    //     e.preventDefault();
    
    //     const response = await fetch("/cart.js");
    //     const cart = await response.json();
    
    //     const restrictedSellingPlans = ["690463310099", "690196447507", "690196480275"];
    
    //     const hasRestrictedPlan = cart.items.some(item => 
    //         item.selling_plan_allocation && 
    //         restrictedSellingPlans.includes(item.selling_plan_allocation.selling_plan.id.toString())
    //     );

    //     console.log("cart");
    //     console.log(cart);
    //     console.log(hasRestrictedPlan);
    
    //     if (hasRestrictedPlan) {
    //         await fetch("/cart/clear.js", { method: "POST" });

    //         location.reload();
    //     } else {
    //         window.location.href = "/checkout";
    //     }
    // });

    document.querySelectorAll('[href="#trigger"]').forEach(button => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        const targetSelector = this.getAttribute('title');
        const targetElement = document.querySelector("#" + targetSelector);
        if (targetElement) {
            targetElement.click();
        }
      });
    });

    
                                    
    this.container.delegateListener("click", `.button[data-settings]`, async function(e) {
      const _this = e.target;
      const data = JSON.parse(_this.dataset.settings);
      const lineItemKey = data.key;
      const quantity = data.quantity;
      const newVariantId = data.variant;
      const selling_plan = data.plan;
      const cartMessage = data.messages[0];
      const checkoutMessage = data.messages[1];
      let properties = {
      }
      
      properties[window.theme.cart_message] = cartMessage;
      properties[window.theme.checkout_message] = checkoutMessage;
      properties[window.theme.product_type_key] = "Subscription";
    
      try {
        await fetch(`/cart/change.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: lineItemKey,
            quantity: 0,
          }),
        });

        await fetch(`/cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: newVariantId,
            quantity: quantity,
            selling_plan: selling_plan,
            properties: properties
          }),
        });
      
        
        if(document.querySelector("cart-drawer-items")) {
          this.updateCartContent();
          document.querySelector("cart-drawer-items").dispatchEvent(new Event('cart:refreshSingle'));
        }

        this.cartUpsellAuto();
        
      } catch (error) {
        console.error("Error upgrading item:", error);
        alert("An error occurred. Please try again.");
      }
    }.bind(this));
    
    document.addEventListener("DOMContentLoaded", () => {
      document.querySelectorAll(".button[data-settingss]").forEach((button) => {
        button.addEventListener("click", async (event) => {
          const data = JSON.parse(document.querySelector(".button[data-settings]").dataset.settings);
          const lineItemKey = data.key;
          const newVariantId = data.variant;
          const selling_plan = data.plan;
          const cartMessage = data.messages[0];
          const checkoutMessage = data.messages[1];
          
          let properties = {
          }
          
          properties[window.theme.cart_message] = cartMessage;
          properties[window.theme.checkout_message] = checkoutMessage;
          properties[window.theme.product_type_key] = "Subscription";
          
          try {
            await fetch(`/cart/change.js`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: lineItemKey,
                quantity: 0,
              }),
            });
  
            await fetch(`/cart/add.js`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: newVariantId,
                quantity: 1,
                selling_plan: selling_plan,
                properties: {
                  "_Subscription": cartMessage,
                  "Information": checkoutMessage,
                }
              }),
            });

            
            this.updateCartContent();
            document.querySelector("cart-drawer-items").dispatchEvent(new Event('cart:refresh'));
            // location.reload();
          } catch (error) {
            console.error("Error upgrading item:", error);
            alert("An error occurred. Please try again.");
          }
        });
      });
    });
    
    document.addEventListener('DOMContentLoaded', () => {
      if(document.querySelector('.section--wrapper[data-color]')) {
        
      const sections = document.querySelectorAll('.section--wrapper[data-color]');
      const threshold = 0.80;

      const changeBackgroundColor = () => {
        let currentColor = '#fff';

        sections.forEach(section => {
          const rect = section.getBoundingClientRect();
          const sectionTop = rect.top;
          const sectionHeight = rect.height;
          const viewportHeight = window.innerHeight;

          if (sectionTop < viewportHeight * threshold && sectionTop + sectionHeight > viewportHeight * threshold) {
            currentColor = section.getAttribute('data-color');
          }
        });

        document.body.style.backgroundColor = currentColor;
      };

      window.addEventListener('scroll', changeBackgroundColor);
      window.addEventListener('resize', changeBackgroundColor);
      changeBackgroundColor(); // Initial check
      }
    });
    
    if(document.querySelector('.image-line--wrapper')) {
document.addEventListener('DOMContentLoaded', () => {
  
    const imageLineWrappers = document.querySelectorAll('.image-line--wrapper');

    imageLineWrappers.forEach(wrapper => {
      // console.log(wrapper);
        let heightMod = window.innerWidth < 800 ? 0.90 : 2.2; 
        const imageLine = wrapper.querySelector('.image-line');
        const container = wrapper.closest(`.section-lines`);
        let startScrollPosition = 0;
        let isSectionVisible = false;
        let initialTranslateX = 0;
        let translateDirection = 'left'; // Initial direction
        let fullWidth = calculateSumOfChildrenWidths(imageLine) - window.innerWidth;

        // Check for line-reverse class
        if (imageLine.classList.contains("line-reverse")) {
            translateDirection = 'right';
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Section becomes visible
                    if (!isSectionVisible) {
                        startScrollPosition = window.scrollY;
                        initialTranslateX = getTranslateX(imageLine);
                        isSectionVisible = true;
                        updateTranslate(wrapper, startScrollPosition, initialTranslateX);
                        window.addEventListener('scroll', onScroll);
                    }
                } else {
                    // Section is not visible
                    isSectionVisible = false;
                    window.removeEventListener('scroll', onScroll);
                }
            });
        }, {
            root: null, // Use the viewport as the root
            threshold: 0 // Trigger when any part of the element is visible
        });

        observer.observe(container);

        function onScroll() {
            heightMod = window.innerWidth < 800 ? 0.90 : 2.2; 
          
            if (isSectionVisible) {
                const scrollPosition = (window.scrollY - startScrollPosition) / (window.innerHeight * heightMod);
                let currentTranslateX = initialTranslateX;

              
                if (translateDirection === 'left') {
                    currentTranslateX -= scrollPosition * fullWidth; // Move to the left
                  if(currentTranslateX < (-1 * fullWidth)) {
                    currentTranslateX = (-1 * fullWidth) * 1.0869;
                  }
                  
                  if(currentTranslateX > 0) {
                    currentTranslateX = 0;
                  }
                } else {
                    currentTranslateX += scrollPosition * fullWidth; // Move to the right
                  if(currentTranslateX > fullWidth) {
                    currentTranslateX = fullWidth * 1.0869;
                  }
                  
                  if(currentTranslateX < 0) {
                    currentTranslateX = 0;
                  }
                }

                imageLine.style.transform = `translateX(${currentTranslateX}px)`;
            }
        }

        function calculateSumOfChildrenWidths(container) {
            // Get all child elements of the container
            const children = container.children;
            // Initialize the sum of widths
            let totalWidth = 0;
            // Iterate through each child element and sum their widths
            for (let i = 0; i < children.length; i++) {
                totalWidth += children[i].offsetWidth;
            }
            // Return the total width
            return totalWidth;
        }

        function updateTranslate(wrapper, startScrollPosition, initialTranslateX) {
            const scrollPosition = (window.scrollY - startScrollPosition) / (window.innerHeight * heightMod);
            let currentTranslateX = initialTranslateX;

            if (translateDirection === 'left') {
                currentTranslateX -= scrollPosition * fullWidth; // Move to the left
            } else {
                currentTranslateX += scrollPosition * fullWidth; // Move to the right
            }

            imageLine.style.transform = `translateX(${currentTranslateX}px)`;
        }

        // Initial translate position on load
        const wrapperRect = wrapper.getBoundingClientRect();
        if (wrapperRect.top < window.innerHeight && wrapperRect.bottom > 0) {
            // If section is within the viewport, initialize it normally
            startScrollPosition = window.scrollY;
            initialTranslateX = getTranslateX(imageLine);
            updateTranslate(wrapper, startScrollPosition, initialTranslateX);
        } else if (wrapperRect.top >= window.innerHeight) {
          if (translateDirection === 'left') {
              imageLine.style.transform = `translateX(0px)`;
          } else {
              imageLine.style.transform = `translateX(0px)`;
          }
        } else if (wrapperRect.bottom <= 0) {
          if (translateDirection === 'left') {
              imageLine.style.transform = `translateX(-${fullWidth}px)`;
          } else {
              imageLine.style.transform = `translateX(${fullWidth}px)`;
          }
        }
    });

    function getTranslateX(element) {
        const style = window.getComputedStyle(element);
        const transform = style.transform;
        let matrix = transform.match(/^matrix\((.+)\)$/);
        if (matrix) {
            return parseFloat(matrix[1].split(', ')[4]);
        }
        return 0;
    }
});
      
      


    }
    
    if(document.querySelector(`[data-template^="product"]`)) {
      this.checkElement(".kl_reviews__star_rating_widget__label", function(element) {
        // console.log('Element found:', element);
        // console.log('Element found:', element.innerText);
        // element.innerText = element.innerText.replace("Ratings", window.theme.subsriptionStrings.ratings);
        // element.innerText = `<span>${element.innerText.split(" ")[0]} ${ window.theme.subsriptionStrings.ratings }</span>`;
         element.style.fontSize = "0"

        if(!element.querySelector("span")) {
           element.insertAdjacentHTML('beforeend', `<span>${element.innerText.split(" ")[0]} ${ window.theme.subsriptionStrings.ratings }</span>`);
        }
        // element.insertAdjacentHTML('beforeend', `<span>${element.innerText.split(" ")[0]} ${ window.theme.subsriptionStrings.ratings }</span>`);
      });
    }
    
    if(document.querySelector(`[data-template^="product"]`) && document.querySelector(`[data-addsubdetails]`)) {
      document.addEventListener("DOMContentLoaded", (event) => {
        this.initProductSubscription({
          detailsSelector: "[data-addsubdetails]",
          optionsSelector: "[data-option]",
          priceSelector: "[data-price]"
        });

        if(document.querySelector(`.product__additional_options`)) {
          this.initProductSubscription({
            detailsSelector: ".product__additional_options",
            optionsSelector: "[data-option]",
            priceSelector: "[data-price]"
          });
        }
      });
    }

    this.container.delegateListener("click", `#CartDrawer-Checkout`, function(e) {
      const form = document.getElementById('CartDrawer-Form');
      const termsCheckbox = document.getElementById('terms');
      const termsCheckboxWrapper = document.querySelector('.terms');
  
        if (!termsCheckbox.checked) {
          e.preventDefault();
          termsCheckboxWrapper.classList.add("style--error");
          // setTimeout(() => {
          //   termsCheckboxWrapper.classList.remove("style--error");
          // }, 500);
        } else {
          
        }
    }.bind(this));
    
    this.initSlider(`.drawer__upsell .swiper`);
    
    this.container.delegateListener("click", "[data-upsell-button]", function(e) {
      this.cartUpsellButton(event);
    }.bind(this));
    
    this.container.delegateListener("click", "[data-upsell-btn]", function(e) {
      this.productUpsellButton(event);
    }.bind(this));
    
    this.container.delegateListener("click", ".product-badges", function(e) {
      let _this = event.target.closest(".product-badges");
      e.preventDefault();
      console.log(e.target);
      _this.classList.toggle("is_active");
      
    }.bind(this));
    
    window.on = Element.prototype.on = this.delegate.on;
    window.off = Element.prototype.off = this.delegate.off;
    this.initCollapsable();
    this.videoControls(".video--container");

    document.querySelectorAll(".section--wrapper").forEach((element, index) => {
      element.style.zIndex = index;
    });
    
    this.container.delegateListener("click", "[data-buy]", function(event) {
      document.querySelector(".product-form__submit").scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }.bind(this));
    
    this.container.delegateListener("click", "[data-load]", function(event) {
      let _this = event.target;
      let url = _this.dataset.load + "?view=data";
      let container = _this.closest("section").querySelector("[data-container]");

      this.loadInContent(url, container);
    }.bind(this));

    document.querySelectorAll("[data-blog]").forEach((element, index) => {
      let url = element.dataset.blog + "?view=data_list";

      this.loadInContent(url, element);
    });
    
    document.querySelectorAll(".style--hoverToch").forEach((element, index) => {

      element.addEventListener('touchstart', function(event) {
        element.classList.add('hover-effect');
      }, { passive: true });
    
      element.addEventListener('touchend', function(event) {
        setTimeout(function() {
          element.classList.remove('hover-effect');
        }, 200);
      }, { passive: true });
    });
    
    this.container.delegateListener("click", "[data-notify]", function(event) {
      // document.querySelector(".klaviyo-bis-trigger").click();
    }.bind(this));
    
    this.container.delegateListener("click", "[data-popup_trigger]", function(event) {
      event.preventDefault();
      if(event.target.closest("[data-section='passive_popup']")) {
        this.container.setAttribute('data-hidden', `false`);
        document.querySelector("[data-section='passive_popup'] [data-active]").setAttribute('data-active', `false`);
        return;  
      }
      
      const container = event.target.closest("[data-popup-wrapper]");
      const popup = container.querySelector("[data-active]");

      document.querySelectorAll("[data-popup='true']").forEach(function(element) {
        if(element != popup) {
          element.setAttribute('data-popup', "false");
        }
      });
      
      this.container.setAttribute('data-hidden', `${!(popup.getAttribute('data-active') === 'true')}`);
      popup.setAttribute('data-active', `${!(popup.getAttribute('data-active') === 'true')}`);

      if(popup.querySelector(`[data-block="content_tabs"]`)) {
        popup.querySelectorAll(`[data-block="content_tabs"] li`).forEach((element, index) => {
          element.classList.remove("active");
        });
      }
    }.bind(this));

    this.container.delegateListener("click", "popup-wrapper[data-active=true]", function(event) {
      if(event.target.closest(".popup")) {
        return;  
      }

      event.preventDefault();
      this.container.setAttribute('data-hidden', `false`);
      event.target.setAttribute('data-active', `false`);
    }.bind(this));
    
    this.container.delegateListener("click", "[data-section] sup", function(event) {
      event.preventDefault();

      if(event.target.closest(".popup")) {
        return;  
      }
      
      const popup = document.querySelector("[data-section='passive_popup'] [data-active]");
      document.querySelectorAll("[data-popup='true']").forEach(function(element) {
        if(element != popup) {
          element.setAttribute('data-popup', "false");
        }
      });
      
      this.container.setAttribute('data-hidden', `${!(popup.getAttribute('data-active') === 'true')}`);
      popup.setAttribute('data-active', `${!(popup.getAttribute('data-active') === 'true')}`);

      if(popup.querySelector(`[data-block="content_tabs"]`)) {
        popup.querySelectorAll(`[data-block="content_tabs"] li`).forEach((element, index) => {
          element.classList.remove("active");
        });
      }
    }.bind(this));

    this.container.delegateListener("click", `[data-trigger="search"]`, function(event) {
      document.querySelector(".header__icon--search").click();
    });
    
    window.addEventListener("load", (event) => {
      window.Custom.updateCartErrorState("load");
      
      document.querySelectorAll(".animate-in").forEach(function(element) {
        element.classList.add("animated");
      });
    });

    this.container.delegateListener("click", `[href*="#addProdSub"]`, function(event) {
      // document.querySelector(".shopify_subscriptions_app_block_label label").click();
      document.querySelector(".product__custom_subsriptions label").click();
      
      document.querySelector(`[name="add"]`).click();
    });
  },

  updateCartErrorState: function(caller = "") {
    let europa = [
      "AL", "AD", "AT", "BY", "BE", "BA", "BG", "HR", "CY", "CZ",
      "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IS", "IE", "IT",
      "XK", "LV", "LI", "LT", "LU", "MT", "MD", "MC", "ME", "NL",
      "MK", "NO", "PL", "PT", "RO", "RU", "SM", "RS", "SK", "SI",
      "ES", "SE", "UA", "GB", "VA"
    ];
    
    setTimeout(() => {
      if(document.querySelector(".cart__ctas .button")) {
        document.querySelector(".cart__ctas .button").removeAttribute("disabled");
      }
    }, 3000);
    
    // if(!(europa.indexOf(window.theme.location) === -1 && window.theme.usa_thresshold > 0)) {
    //   return;
    // }
    if (
      (europa.indexOf(window.theme.location) === -1 && window.theme.usa_thresshold > 0) ||
      (window.theme.location === "CH" && window.theme.ch_thresshold > 0)
    ) {
      
    } else {
      return;
    }
    
    const cartDrawer = document.querySelector("cart-drawer");
    if(!cartDrawer) {
      return;
    }
    let threshold = window.theme.usa_thresshold * Number(Shopify.currency.rate);
    let threshold_text = window.theme.usa_thresshold_error;
    if(window.theme.location === "CH" && window.theme.ch_thresshold > 0) {
      threshold = window.theme.ch_thresshold * Number(Shopify.currency.rate);
      threshold_text = window.theme.ch_thresshold_error;
    }

    console.log("threshold: ", threshold, window.theme.usa_thresshold, window.theme.ch_thresshold, Shopify.currency.rate);
    
    const errorBlock = cartDrawer.querySelector(".drawer__error");
    const buttonBlock = cartDrawer.querySelector("#CartDrawer-Checkout");
    const upsellBlock = cartDrawer.querySelector(".drawer__upsell");
    const ctaBlock = cartDrawer.querySelector(".cart__ctas");
    const total = parseInt(buttonBlock.dataset.total);
    const errorState = total > threshold;

    errorBlock.querySelector(".text--wrapper").textContent = threshold_text;
    
    
    if(errorState) {
      if(errorBlock && errorBlock !== null) {
        errorBlock.classList.remove("hide");
      }
      if(ctaBlock && ctaBlock !== null) {
        ctaBlock.classList.add("hide");
      }
      if(upsellBlock && upsellBlock !== null) {
        upsellBlock.classList.add("hide");
      }
      if(buttonBlock && buttonBlock !== null) {
        buttonBlock.toggleAttribute("disabled", true);
      }
    } else {
      if(errorBlock && errorBlock !== null) {
        errorBlock.classList.add("hide");
      }
      if(ctaBlock && ctaBlock !== null) {
        ctaBlock.classList.remove("hide");
      }
      if(upsellBlock && upsellBlock !== null) {
        upsellBlock.classList.remove("hide");
      }
      if(buttonBlock && buttonBlock !== null) {
        buttonBlock.toggleAttribute("disabled", false);
      }
    }

    // console.log("Drawer blocks: ", errorBlock, ctaBlock, upsellBlock, buttonBlock);
  },
  
  twitterConversion: function(response) {
    
  },
  
  checkElement: function(selector, callback) {
    let count = 0;
    const checkHandler = function() {
      let element = document.querySelector(selector);
      count++;
      if (element) {
        callback(element);
        if(count > 20) {
          clearInterval(interval);
        }
        
      } else {
        // console.log("check ", count);
        if(count > 30) {
          clearInterval(interval);
        }
      }
    };
    
    let interval = setInterval(checkHandler, 250);
  },
  
  accountPopup: function() {
    this.container.delegateListener("click", ".custom-account button", function(e) {
      e.preventDefault();
      let _this = event.target.closest(".custom-account");
      let popup = _this.querySelector(".popup--wrapper");

      this.closeAllPopups(popup);
      popup.setAttribute("data-active", (popup.getAttribute("data-active") == "false"));
    }.bind(this));

    this.container.delegateListener("click", ".custom-account .popup--wrapper", function(e) {
      let _this = event.target;
      let popup = _this.closest(".custom-account").querySelector(".popup--wrapper");

      if(!_this.closest(".popup--inner")) {
        popup.setAttribute("data-active", (popup.getAttribute("data-active") == "false"));
      }
    }.bind(this));
  },
  
  localizationPopup: function() {
    window.addEventListener("load", (event) => {
      if(location.pathname.indexOf("/es") > -1 || location.pathname.indexOf("/en") > -1 || location.pathname.indexOf("/de") > -1 || location.pathname.indexOf("/fr") > -1 || location.pathname.indexOf("/it") > -1) {
        this.setCookie("localization_cookie", "true", 14);
      }
  
      let localizationCookie = this.getCookie("localization_cookie");
      // console.log("localizationCookie: ", localizationCookie);
      
      if(!localizationCookie) {
        document.querySelector(".custom-localization button").click();
      } else {
        
      }
    });
    
    this.container.delegateListener("click", ".custom-localization button", function(e) {
      e.preventDefault();
      let _this = event.target.closest(".custom-localization");
      let popup = _this.querySelector(".popup--wrapper");

      if(popup.getAttribute("data-active") == "true") {
        // this.setCookie("localization_cookie", "true", 14);
      }
      
      this.closeAllPopups(popup);
      popup.setAttribute("data-active", (popup.getAttribute("data-active") == "false"));
    }.bind(this));

    this.container.delegateListener("click", ".custom-localization .popup--wrapper", function(e) {

      let _this = event.target;
      let popup = _this.closest(".custom-localization").querySelector(".popup--wrapper");

      if(!_this.closest(".popup--inner")) {
        popup.setAttribute("data-active", (popup.getAttribute("data-active") == "false"));
        // this.setCookie("localization_cookie", "true", 14);
      }
    }.bind(this));
  },

  closeAllPopups: function(current) {
    let popups = document.querySelectorAll(".popup--wrapper");
    popups.forEach((el) => {
      if(el !== current) {
        el.setAttribute("data-active", "false");
      }
      
    });
  },
  
  loadInContent: (url, container) => {
    container.classList.add("loading");
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          console.log(response);
          throw new Error('Problem with loading in products');
        }
        return response.text()
      })
      .then((responseText) => {
        let productData = new DOMParser().parseFromString(responseText, 'text/html');
        
        setTimeout(() => {
          container.innerHTML = responseText;
          container.classList.remove("loading");
        }, 550);
      })
      .catch((error) => { console.error(error); });
  },
  
  initTimer: () => {
    let container = document.querySelector("timer");

    let updateTimer = () => {
      let today = new Date();
      let date = Date.parse(container.dataset.date);

      let diffTime = (date - today) / 1000;
      
      let days = Math.floor(diffTime / 86400);
      let hours = Math.floor((diffTime - days * 86400) / 3600) % 24;
      let minutes = Math.floor((diffTime - hours * 3600) / 60) % 60;
      let seconds = Math.floor(diffTime % 60); 

      if(minutes > 0 && hours > 0) {
        container.textContent = `Offer ends in ${ days > 0 ? (days + " days ") : "" } ${ hours > 0 ? (hours + "hrs ") : "" } ${ minutes }min ${ seconds }sec `;
      } else {
        container.textContent = `Offer ended`;
      }
    }

    if(container) {
      setInterval(updateTimer, 1000);
      setTimeout(() => {
        window.onResizeFunction();
      }, 1000);
    }
  },

  initSlider: function(selector) {
    let element = document.querySelector(selector);
    if(element) {
      let config = JSON.parse(element.dataset.config)
      if(element.querySelector(".swiper-pagination")) {
        config.pagination = {
          el: '.swiper-pagination',
          clickable: true
        }
      }
      new Swiper(selector, config);
    }

    this.setCheckoutUtm();
  },

  // UPSELL
  cartUpsellAuto: function (qty, cart) {
  console.log("upsell: auto");
  const upsellGifts = JSON.parse(document.querySelector("[data-gifts]")?.dataset.gifts || '{}');
  const gift1Id = parseInt(upsellGifts.gift1);
  const gift2Id = parseInt(upsellGifts.gift2);
  const gift3Id = parseInt(upsellGifts.gift3);

  const updateCheckout = (bool = true) => {
    const button = document.querySelector(".cart__ctas .button");
    if (button) button.setAttribute("disabled", bool);
  };

  const updateContent = (responseText) => {
    const htmlData = new DOMParser().parseFromString(responseText, 'text/html');
    const sourceDrawer = htmlData.querySelector('.drawer__inner');
    const sourceWrapper = htmlData.querySelector('cart-drawer');

    if (sourceDrawer) {
      document.querySelector(".drawer__inner").innerHTML = sourceDrawer.innerHTML;
    }

    if (sourceWrapper?.classList.contains("is-empty")) {
      document.querySelector("cart-drawer")?.classList.add("is-empty");
    }

    document.querySelector('#CartDrawer-Overlay')?.addEventListener('click', function () {
      document.querySelector("cart-drawer")?.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    });

    window.Custom.initSlider(`.drawer__upsell .swiper`);

    const drawerCount = htmlData.querySelector("[data-cart-count]");
    if (drawerCount) {
      document.querySelector(".cart-count-bubble span:first-child").innerHTML = drawerCount.innerHTML;
    }

    window.Custom.updateCartErrorState("upsell");
  };

  const updateProduct = (updates) => {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates,
        sections: "cart-data"
      })
    })
    .then(response => response.json())
    .then(response => updateContent(response.sections["cart-data"]))
    .catch(error => console.error('Error updating cart:', error));
  };

  const analyzeCart = (cart) => {
    let attributes = cart.attributes?.["Upsell product"] || "";
    let productCount = 0;
    let subscriptionCount = 0;
    let customCount = 0;
    let bundleCount = 0;
    const giftQuantities = {
      [gift1Id]: 0,
      [gift2Id]: 0,
      [gift3Id]: 0
    };

    cart.items.forEach((item) => {
      // product_type": "Bundle"
      const isGift = [gift1Id, gift2Id, gift3Id].includes(item.id);
      const isSubscription = item.properties?._Product === "Subscription" ;
      const isBundle = item.product_type === "Bundle" ;

      console.log(item, item.title, isSubscription);

      if (!isGift) {
        productCount += item.quantity;
        if (isSubscription) subscriptionCount += item.quantity;
        if (isBundle && isSubscription) bundleCount += item.quantity;
        
        if(item.title == "Premium Hair Complex 2-Bottle System") {
          customCount += item.quantity;
        }
      } else {
        giftQuantities[item.id] = item.quantity;
      }

    });

    const updates = {};

    console.log("customCount:", customCount);
    
    // Gift 1 logic: One gift per product
    if (giftQuantities[gift1Id] !== (productCount - customCount)) {
      if(attributes.indexOf(gift1Id) > -1) {
        console.log("skip 1:", attributes, gift1Id);
      } else {
        updates[gift1Id] = (productCount - customCount);
      }
    }

    const applyGift3 = subscriptionCount >= 2 || bundleCount >= 1;
    const applyGift2 = !applyGift3 && productCount >= 1;

    // Gift 2 logic (only if gift 3 is not applied)
    if (giftQuantities[gift2Id] !== (applyGift2 ? 1 : 0)) {      
      if(attributes.indexOf(gift2Id) > -1) {
        
        console.log("skip 2:", attributes, gift2Id);
      } else {
        updates[gift2Id] = applyGift2 ? 1 : 0;
      }
    }

    // Gift 3 logic overrides gift 2
    if ((giftQuantities[gift3Id] > 0) !== applyGift3) {      
      if(attributes.indexOf(gift3Id) > -1) {
        console.log("skip 3:", attributes, gift3Id);
      } else {
        updates[gift3Id] = applyGift3 ? 1 : 0;
      }
    }

    console.log(giftQuantities, updates, productCount);
    
    if (Object.keys(updates).length > 0) {
      updateProduct(updates);
    } else {
      updateCheckout(false);
    }
  };

  updateCheckout();

  if (qty !== undefined && qty !== null) {
    updateProduct({ [gift1Id]: qty });
  } else if (cart !== undefined) {
    // if (cart.attributes?.["Upsell product"]) return;
    analyzeCart(cart);
  } else {
    fetch('/cart.js', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
      .then(response => response.json())
      .then(cartObject => {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ attributes: { 'Upsell product': '' } })
        }).then(response => {
          if (!response.ok) throw new Error('Network response was not ok.');
          return response.json();
        }).then(() => {
          analyzeCart(cartObject);
        });
      })
      .catch(error => {
        console.error('Error loading or updating cart:', error);
      });
  }
},

  updateCartAttribute: function(attributes, callback) {
    var formData = {
      attributes: attributes
    };
    
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      throw new Error('Network response was not ok.');
    })
    .then(data => {
      console.log('Cart attributes updated successfully:', data);
      callback;
    })
    .catch(error => {
      console.error('There was a problem updating cart attributes:', error);
    });
  },
  
  cartUpsellButton: function(event) {
    let _this = event.target; 
    let data = JSON.parse(_this.closest(`[data-details]`).dataset.details)[0]; 
    let id = _this.dataset.upsellButton; 
    let items = [
      {"id": id, "quantity": 1, "properties": {}}
    ];

    if(data.checkout_message) {
      items[0].properties[window.theme.product_type_key] = "Single";
      items[0].properties[window.theme.cart_message] = data.cart_message;
      items[0].properties[window.theme.checkout_message] = data.checkout_message;
    }
    
    _this.classList.add("button--loading");
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 'items': items })
    }).then(response => {
      this.updateCartContent();
      document.querySelector("cart-drawer-items").dispatchEvent(new Event('cart:refresh'));
      _this.classList.remove("button--loading");
    }).catch((error) => { });
  },
  
  productUpsellButton: function(event) {
    let _this = event.target; 
    let id = _this.dataset.upsellBtn; 
    let productPrice = _this.dataset.price; 
    let items = {"id": id, "quantity": 1};

    let europa = [
      "AL", "AD", "AT", "BY", "BE", "BA", "BG", "HR", "CY", "CZ",
      "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IS", "IE", "IT",
      "XK", "LV", "LI", "LT", "LU", "MT", "MD", "MC", "ME", "NL",
      "MK", "NO", "PL", "PT", "RO", "RU", "SM", "RS", "SK", "SI",
      "ES", "SE", "CH", "UA", "GB", "VA"
    ];
    let formData = {
     'items': [],
      "sections": "cart-data"
    };
    
    // let { cartMessage, checkoutMessage } = _this.closest(`[data-cart-message]`).dataset;
    // if (cartMessage || checkoutMessage) {
    //   items.properties = {};
    //   items.properties["_Product"] = "Single";
    //   if (cartMessage) items.properties[window.theme.cart_message] = cartMessage;
    //   if (checkoutMessage) items.properties[window.theme.checkout_message] = checkoutMessage;
    // }

    
    if(_this.closest(`[data-cart-message]`)) {
      let { cartMessage, checkoutMessage } = _this.closest(`[data-cart-message]`).dataset;
      if (cartMessage || checkoutMessage) {
        items.properties = {};
        items.properties["_Product"] = "Single";
        if (cartMessage) items.properties[window.theme.cart_message] = cartMessage;
        if (checkoutMessage) items.properties[window.theme.checkout_message] = checkoutMessage;
      }
    }
    
    formData.items.push(items);
    // console.log(formData);


    // let items = { id, quantity: 1 };
    // let formData = { items: [], sections: "cart-data" };
  
    // if (plan && !subscriptionCheckbox) {
    //   productPrice = subscriptionPrice;
    //   items.selling_plan = plan;
  
    //   let { cartMessage, checkoutMessage } = container.dataset;
    //   if (cartMessage || checkoutMessage) {
    //     items.properties = {};
    //     if (cartMessage) items.properties[window.theme.cart_message] = cartMessage;
    //     if (checkoutMessage) items.properties[window.theme.checkout_message] = checkoutMessage;
    //   }
    // }
  
    // formData.items.push(items);

    _this.classList.add("button--loading");
    if(europa.indexOf(window.theme.location) === -1 && window.theme.usa_thresshold > 0) {
      fetch('/cart.js', { method: 'GET', headers: {'Content-Type': 'application/json;'}})
      .then((response) => {
        return response.json();
      }).then((cartObject) => {
        const total = cartObject.total_price;
        const rate = Number(Shopify.currency.rate);
        const totalNormal = cartObject.items.reduce((sum, currentValue) => {
          if (currentValue.variant_title === "12-Month Supply") {
            return sum;
          } else {
            return sum + currentValue.line_price;
          }
        }, 0);
  
        if((totalNormal + productPrice * 1) > (window.theme.usa_thresshold * rate)) {
          document.querySelector("[data-cart_popup]").click();
          _this.classList.remove("button--loading");
          return;
        }
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then(response => {
          if(document.querySelector("cart-drawer-items")) {
            this.updateCartContent();
            document.querySelector("cart-drawer-items").dispatchEvent(new Event('cart:refresh'));
          }
          
          document.querySelector('#cart-icon-bubble').click();
          _this.classList.remove("button--loading");
        })
        .catch((error) => {
          console.error('Error:', error);
          _this.classList.remove("button--loading");
        });
        
      }).catch(() => { });
    } else {
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then((response) => response.json())
      .then(response => {
        if(document.querySelector("cart-drawer-items")) {
          this.updateCartContent();
          document.querySelector("cart-drawer-items").dispatchEvent(new Event('cart:refresh'));
        }
        document.querySelector('#cart-icon-bubble').click();
        _this.classList.remove("button--loading");
      })
      .catch((error) => {
        console.error('Error:', error);
          _this.classList.remove("button--loading");
      });
    }
  },
  
  updateCartContent: function(event) {
    fetch(window.Shopify.routes.root + "?sections=cart-drawer")
    .then((response) => response.json())
    .then((response) => {
      let selector = "#CartDrawer";
      let drawer = document.querySelector(selector)
      drawer.innerHTML = new DOMParser().parseFromString(response["cart-drawer"], 'text/html').querySelector(selector).innerHTML;
      this.initSlider(`.drawer__upsell .swiper`);
      this.setCheckoutUtm();
    });
  },
  
  initProductSubscription: function(selectors)  {
    const { detailsSelector, optionsSelector, priceSelector } = selectors;
    const detailsElement = document.querySelector(detailsSelector);
    const priceElement = document.querySelector(priceSelector);
    const optionsElements = detailsElement ? detailsElement.querySelectorAll(optionsSelector) : null;

    // console.log(optionsElements, selectors);
    
    if (!detailsElement || !detailsElement || !optionsElements) {
      console.error('One or more required elements are missing.');
      console.error(detailsElement, detailsSelector);
      console.error(optionsElements, optionsSelector);
      return;
    }
    
    document.querySelector(".product__price").classList.add("hide");
    
    let priceValue = JSON.parse(detailsElement.dataset.originalprice) / 100;
    let details = JSON.parse(detailsElement.dataset.addsubdetails);
 
    optionsElements.forEach((element) => {
      let input = element.querySelector("input");
      if(element.dataset.option != "") {
        // console.log(element);
        this.setSubscriptionContent(element, JSON.parse(element.dataset.option), (JSON.parse(document.querySelector("[data-sub-details]").dataset.originalPrice) / 100));
      } else if(details) {
        this.setSubscriptionContent(element, details, priceValue);
      }

      if(input) {
        input.insertAdjacentHTML('afterend', `<span class="icon"></span>`);
      }
    });

    if(document.querySelector(".product-form__submit")) {
      document.querySelector(".product-form__submit").removeAttribute("disabled");
    }
  },
  
  initProductSubscriptionCustom: function()  {
    let popBadge = "";
    const details = JSON.parse(document.querySelector("[data-sub-details]").dataset.subDetails);
    const priceValue = JSON.parse(document.querySelector("[data-sub-details]").dataset.originalPrice) / 100;
    const priceContainer = document.querySelector(".price__container");
    const priceTarget = document.querySelector("[data-price]");
    const strings = window.theme.subsriptionStrings;
    document.querySelector(".product__price").classList.add("hide");

    document.addEventListener("DOMContentLoaded", (event) => {

        const options = document.querySelectorAll(".shopify_subscriptions_app_block_label");
        const subOptions = document.querySelectorAll(".shopify_subscriptions_app_block_label_children");

        if(document.querySelector(".shopify_subscriptions_app_container")) {
          document.querySelector(".shopify_subscriptions_app_container").classList.add("style--custom");
        }

      
        if(subOptions.length < 2) {
          subOptions.forEach((element) => {
            element.classList.add("hide");
          });
        }

        options.forEach((element) => {
          let option = element.querySelector("label");
          let currentDetails = {};
          let input = element.querySelector("input");
          let price = 0;
          let pricePer = 0;
          let qty = 1;
          let discount = 1;
          let comparePrice = ``;
          let priceDiff = ``;
          let times = 1;
          let badge = ``;
          let container = element.firstElementChild.classList.contains("shopify_subscriptions_purchase_option_wrapper") ? element.querySelector(".shopify_subscriptions_app_block_label_children label") : option;
          
          if(details) {
            details.forEach((el) => {
              if(el.subscription_title === option.textContent.trim()) {
                currentDetails = el;
              }
            });

            console.log(currentDetails, option.textContent.trim(), !currentDetails.title);
            if(!currentDetails.title) {
              console.log(element, element.parentElement);
              // element.parentElement.classList.add("hide");
              return;
            }
  
            discount = currentDetails.discount ? 1 - currentDetails.discount * 0.01 : 1;
            qty = currentDetails.amount ? currentDetails.amount : 1;
            times = currentDetails.times ? currentDetails.times : 1;

            if(document.querySelector("[data-badge-value]")) {
              popBadge = `<span class="popularBadge">${ document.querySelector("[data-badge-value]").dataset.badgeValue }</span>`;
            }
            
            // console.log((parseFloat(priceValue) * qty - parseFloat(priceValue * discount).toFixed(2) * qty) * times);
            // console.log(parseFloat(priceValue), qty);
            // console.log(parseFloat(priceValue * discount).toFixed(2), qty);
            // console.log(times);
            
            // console.log(currentDetails.subscription_title);
            // console.log(priceValue, qty, discount, times);
            // console.log((parseFloat(priceValue) * qty - parseFloat(priceValue * discount).toFixed(2) * qty));
            
            if(currentDetails.discount != 0) {
              price = this.calculatePrice3(parseFloat(priceValue * discount).toFixed(2) * qty * 100, 1);
              pricePer = this.calculatePrice3(parseFloat(priceValue * discount) * 100, 60);
              comparePrice = `<s>${ this.calculatePrice3(priceValue * qty, 0.01) }</s>`;
              console.log(currentDetails.label);
            if(currentDetails.label) {
              badge = currentDetails.badge != "" ? `<span>${ currentDetails.badge.replace("[price]", this.calculatePrice3((parseFloat(priceValue) * qty - parseFloat(priceValue * discount).toFixed(2) * qty) * times, 0.01)) }</span> <span class="small">${ currentDetails.label }</span>` : ``;
            
            } else {
              badge = currentDetails.badge != "" ? `<span>${ currentDetails.badge.replace("[price]", this.calculatePrice3((parseFloat(priceValue) * qty - parseFloat(priceValue * discount).toFixed(2) * qty) * times, 0.01)) }</span> <span class="small">${ strings.cancel }</span>` : ``;
            
            }
              
            } else {
              price = this.calculatePrice3(parseFloat(priceValue) * 100, 1);
              pricePer = this.calculatePrice3(parseFloat(priceValue) * 100, 60);
              comparePrice = "";
              badge = currentDetails.badge != "" ? `<span>${ currentDetails.badge }</span>` : ``;
            }
            
            let content = `
              <div class="text--wrapper selection--none">
                ${ (currentDetails.subscription_title == "Monthly subscription" ? popBadge : ``) }
                <ul>
                  <li class="sub-price">${price } ${ comparePrice }</li>
                  <li class="sub-title" data-subtitle="${ this.handlelize(currentDetails.title) }">${ currentDetails.title }</li>
                  <li class="sub-subtitle">${ currentDetails.subtitle }</li>
                  <li class="sub-badge">${ badge }</li>
                  <li class="sub-price_per">${ strings.from } ${ pricePer } ${ strings.per }</li>
                </ul>
              </div>
            `;

            container.classList.add("custom-content");
            container.insertAdjacentHTML('beforeend', content);
          }
  
          if(input) {
            var childNodes = container.childNodes;
            for (var i = 0; i < childNodes.length; i++) {
                var node = childNodes[i];
                if (node.nodeType === Node.TEXT_NODE) {
                    container.removeChild(node);
                }
            }
            
            input.insertAdjacentHTML('afterend', `<span class="icon"></span>`);
          }
        });
      
        if(document.querySelectorAll(".shopify_subscriptions_app_container .custom-content")[2]) {
          document.querySelectorAll(".shopify_subscriptions_app_container .custom-content")[2].click();
        }
    });
  },
  
  setSubscriptionContent: function(element, details, priceValue) {
    const strings = window.theme.subsriptionStrings;
    let currentDetails = {};
    let price = 0;
    let priceValue2 = 0;
    let pricePer = 0;
    let qty = 1;
    let discount = 1;
    let comparePrice = ``;
    let priceDiff = ``;
    let times = 1;
    let addTimes = 1;
    let badge = ``;
    let popBadge = "";
    let popBadgeGlobal = "";
    let giftBadge = "";
    let divider = 60;
    
    details.forEach((el) => { if(el.subscription_title ===element.textContent.trim()) { currentDetails = el;} });

    if(!currentDetails.title) {
      element.parentElement.classList.add("hide");
      return;
    }
  
    discount = currentDetails.discount ? 1 - currentDetails.discount * 0.01 : 1;
    qty = currentDetails.amount ? currentDetails.amount : 1;
    times = currentDetails.times ? currentDetails.times : 1;
  
    if(document.querySelector("[data-badge-value]")) {
      popBadge = `<span class="popularBadge">${ document.querySelector("[data-badge-value]").dataset.badgeValue }</span>`;
    }

    if(theme.subsriptionStrings.badge) {
      popBadgeGlobal = `<span class="popularBadge globalBadge" style="transform: translateY(50%); background: #F1AB18;">${ theme.subsriptionStrings.badge }</span>`;
    }

    // if(currentDetails.badge_top2) {
    //   popBadge = `<span class="popularBadge">${ currentDetails.badge_top2 }</span>`;
    // }
    if (currentDetails.hasOwnProperty('badge_top2')) {
      popBadge = currentDetails.badge_top2.trim() ? `<span class="popularBadge style--black0">${currentDetails.badge_top2}</span>` : ``;
    }
    
    if(currentDetails.subscription_title.indexOf("Annual") > -1) {
      divider = 720;
    } else {
      
      if(window.theme.giftBadge != "") {
        giftBadge = `<span class="giftBadge">${ window.theme.giftBadge }</span>`;
      }
    }

    console.log(currentDetails);
    

    let monthlySub = false;
    if(currentDetails.subscription_title == "Monthly subscription" || currentDetails.subscription_title == "Abbonamento mensile" || currentDetails.subscription_title == "Abonnement mensuel" || currentDetails.subscription_title == "Suscripción mensual" || currentDetails.subscription_title == "Monatliches Abonnement") {
      monthlySub = true;
    }


    if(currentDetails.discount != 0) {
      
      if(currentDetails.add_discount) {
        addTimes = ( 1 - currentDetails.add_discount * 0.01);
      }

      price = this.calculatePrice3(parseFloat(priceValue * discount * addTimes) * qty * 100, 1);
      priceValue2 = parseFloat(priceValue * discount * addTimes).toFixed(2) * qty * 100;
      pricePer = this.calculatePrice3(parseFloat(priceValue * discount * addTimes) * 100, divider);
      comparePrice = `<s>${ this.calculatePrice3(priceValue * qty, 0.01) }</s>`;

      if(currentDetails.label) {
        badge = currentDetails.badge != "" ? `<span>${ currentDetails.badge.replace("[price]", this.calculatePrice3((parseFloat(priceValue) * qty - parseFloat(priceValue * discount).toFixed(2) * qty) * times, 0.01)) }</span> <span class="small">${ currentDetails.label }</span>` : ``;
      } else {
        // if(monthlySub) {
        //   badge = currentDetails.badge != "" ? `<span>${ currentDetails.badge.replace("[price]", this.calculatePrice3((parseFloat(priceValue) * qty - parseFloat(priceValue * discount).toFixed(2) * qty) * times, 0.01)) }</span> <span class="small">${ strings.cancel3 }</span>` : ``;
        // } else {
        //   badge = currentDetails.badge != "" ? `<span>${ currentDetails.badge.replace("[price]", this.calculatePrice3((parseFloat(priceValue) * qty - parseFloat(priceValue * discount).toFixed(2) * qty) * times, 0.01)) }</span> <span class="small">${ strings.cancel }</span>` : ``;
        // }

        badge = currentDetails.badge != "" ? `<span>${ currentDetails.badge.replace("[price]", this.calculatePrice3((parseFloat(priceValue) * qty - parseFloat(priceValue * discount).toFixed(2) * qty) * times, 0.01)) }</span> <span class="small">${ strings.cancel3 }</span>` : ``;
      }
    } else {
      price = this.calculatePrice3(parseFloat(priceValue) * 100, 1);
      priceValue2 = parseFloat(priceValue) * 100;
      pricePer = this.calculatePrice3(parseFloat(priceValue) * 100, divider);
      comparePrice = "";
      badge = currentDetails.badge != "" ? `<span>${ currentDetails.badge }</span>` : ``;
    }
    
    let soldoutContent = ``;
    if(currentDetails.soldout == true) {
      element.classList.add("soldout--wrapper");
      soldoutContent = `
          <li class="sub-soldout">
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path></svg>
              <span>
                ${ window.theme.subsriptionStrings.soldout }
              </span>
            </span>
          </li>`;
    }
    
    let content = `
      <div class="text--wrapper selection--none">
        <div class="badgeWrapper">
          ${ (monthlySub || currentDetails.badge_top2 ? popBadge : ``) }
        
        </div>
        <ul class="block-soldout">
          <li class="sub-price" data-price="${ priceValue2 }">${ price } ${ comparePrice }</li>
          <li class="sub-title" data-subtitle="${ this.handlelize(currentDetails.title) }">${ currentDetails.title }</li>
          <li class="sub-subtitle">${ currentDetails.subtitle }</li>
          <li class="sub-badge">${ badge }</li>
          <li class="sub-price_per">${ strings.from } ${ pricePer } ${ strings.per }</li>
          ${ soldoutContent }
        </ul>
        
        <div class="badgeWrapper" style="top: unset; bottom: -16px;">
          ${ (monthlySub && popBadgeGlobal ? popBadgeGlobal : ``) }
        </div>
      </div>
    `;
    element.classList.add("custom-content");
    element.insertAdjacentHTML('beforeend', content);
  },

  calculatePrice3: function(price, divider) {
    const rate = 1;
    // console.log("calculatePrice3: ", price, divider);
    let formatString = theme.moneyWithCurrencyFormat.indexOf("{amount_with_comma_separator}}") > -1 ? "{amount_with_comma_separator}}" : "{amount}}" ;
    return(theme.moneyWithCurrencyFormat.replace(/\{.*\}/g, (price * rate / 100 / divider).toFixed(2)));
  },
  
  calculatePrice2: function(price, divider) {
    const rate = 1;
    let formatString = theme.moneyFormat.indexOf("{amount_with_comma_separator}}") > -1 ? "{amount_with_comma_separator}}" : "{amount}}" ;
    return(theme.moneyFormat.replace(/\{.*\}/g, (price * rate / 100 / divider).toFixed(2)));
  },
  
  calculatePrice: function(price, divider) {
    const rate = Number(Shopify.currency.rate);
    let formatString = theme.moneyFormat.indexOf("{amount_with_comma_separator}}") > -1 ? "{amount_with_comma_separator}}" : "{amount}}" ;
    return(theme.moneyFormat.replace(/\{.*\}/g, (price * rate / 100 / divider).toFixed(2)));
  },
  
  initCollapsable: function()  {
    var selectors = {
      trigger: `[data-dropwdown="trigger"]`,
      module: `[data-dropwdown="body"]`,
      moduleInner: '.dropdown--inner',
      tabs: '.collapsible-trigger--tab'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };
  
    var namespace = `.list--unset`;
  
    var isTransitioning = false;
  
    var el = document;
    el.querySelectorAll(selectors.trigger).forEach(trigger => {
      var state = trigger.classList.contains(classes.open);
      trigger.setAttribute('aria-expanded', state);
      trigger.off('click' + namespace);
      trigger.on('click' + namespace, toggle);
    });
    
    function toggle(evt) {
      if (isTransitioning) {
        return;
      }
  
      isTransitioning = true;
  
      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);
  
      if (!moduleId) {
        moduleId = el.dataset.controls;
      }
      
      if (!moduleId) {
        return;
      }
      
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }
  
      if (!container) {
        isTransitioning = false;
        return;
      }
  
      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;
  
      if (isTab) {
        if(isOpen) {
          isTransitioning = false;
          return;
        }
  
        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="'+ el.dataset.id +'"]').forEach(el => {
          el.classList.remove(classes.open);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          setTransitionHeight(newModule, 0, true);
        });
      }
      
      if (isOpen && isAutoHeight) {
        setTimeout(function() {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }
  
      if (isOpen && !isAutoHeight) {
        height = 0;
      }
  
      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }
  
      setTransitionHeight(container, height, isOpen, isAutoHeight);
      
      if (parentCollapsibleEl) {
        var parentHeight = parentCollapsibleEl.style.height;
  
        if (isOpen && parentHeight === 'auto') {
          childHeight = 0;
        }
  
        var totalHeight = isOpen
                        ? parentCollapsibleEl.offsetHeight - childHeight
                        : height + parentCollapsibleEl.offsetHeight;
  
        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }
      
      if (window.SPR) {
        var btn = container.querySelector('.spr-summary-actions-newreview');
        if (!btn) { return }
        btn.off('click' + namespace);
        btn.on('click' + namespace, function() {
          height = container.querySelector(selectors.moduleInner).offsetHeight;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        });
      }
    }
  
    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      window.Custom.prepareTransition(container, function() {
        container.style.height = height+'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });
  
      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }
  },
  
  delegate: {
      on: function(event, callback, options){

        if( !this.namespaces ) // save the namespaces on the DOM element itself
          this.namespaces = {};
    
        this.namespaces[event] = callback;
        options = options || false;
    
        this.addEventListener(event.split('.')[0], callback, options);
        return this;
      },
      off: function(event) {
        if (!this.namespaces) { return }
        this.removeEventListener(event.split('.')[0], this.namespaces[event]);
        delete this.namespaces[event];
        return this;
      }
  },
  
  prepareTransition: function(el, callback) {
    el.addEventListener('transitionend', removeClass);

    function removeClass(evt) {
      el.classList.remove('is-transitioning');
      el.removeEventListener('transitionend', removeClass);
    }

    el.classList.add('is-transitioning');
    el.offsetWidth; // check offsetWidth to force the style rendering

    if (typeof callback === 'function') {
      callback();
    }
  },
  
  initContentTabs: function(selector) {   
    const toggleSiblings = (element) => {
      [...element.parentElement.children].forEach(sib => sib.classList.remove('active'));
      element.classList.add("active");
    }
    
    document.querySelectorAll(`[data-block="content_tabs"]`).forEach((element) => {
      let container = element;

      container.delegateListener("click", "[data-trigger]", function(event) {
        const _this = event.target.closest("li");
        _this.classList.toggle("active");
      });
    });
  },
  
  initFeaturedProductsSection: function(selector) {   
    const toggleSiblings = (element) => {
      [...element.parentElement.children].forEach(sib => sib.classList.remove('active'));
      element.classList.add("active");
    }
    
    document.querySelectorAll(`[data-section="featured_products"]`).forEach((element) => {
      let container = element;
      let i = 1;
      let interval = 7000;
      let elements = document.querySelectorAll(`[data-section="featured_products"] .section-middle [data-trigger]`);
      let manualControls = false;
      
      const myInterval = setInterval(function(){
        if(element.classList.contains("manual")) {
          clearInterval(myInterval);
        } else {
          document.querySelectorAll(`[data-section="featured_products"] .section-middle [data-trigger]`)[i].dispatchEvent(new Event('click'));
          i++;
          if(elements.length == i) {
            i = 0;
          }
        }
      }, 4000);
      
      element.addEventListener("click", function(event) {
        if(event.isTrusted) {
          element.classList.add("manual");
        }
      });
        
      document.querySelectorAll(".section-middle [data-trigger]").forEach((triggerElement) => {
        triggerElement.addEventListener("click", function(event) {
          const index = event.target.getAttribute("data-trigger");
          const _this = event.target.closest("li");
          const wrapper = event.target.closest(".section-middle");
          const colour = _this.dataset.colour;
          const topActive = container.querySelector(`.section-top .grid-item:nth-child(${ index })`);
          const bottomActive = container.querySelector(`.section-bottom .grid-item:nth-child(${ index })`);
          
          wrapper.style.setProperty('--border-colour', colour);
          toggleSiblings(_this);
          toggleSiblings(topActive);
          toggleSiblings(bottomActive);
        });
      });
      
    });
  },
    
  initSliderSimple: function(selector) {        
    const element = document.querySelector(selector);
    if(element) {
      let config = JSON.parse(element.dataset.config);
      console.log("test");
      if(element.querySelector(".swiper-pagination")) {
        config.pagination = {
          el: '.swiper-pagination',
          clickable: true
        }
      }
      new Swiper(selector, config);
    }
  },
  
  initSliderResponsive: function(selector, options) {             
    const breakpoint = window.matchMedia(`(min-width: ${ this.mobileBreakpoint })`);
    const enableSwiper = () => { new Swiper (selector, options) };
    const breakpointChecker = () => {
      const mySwiper = document.querySelector(selector);
       if (breakpoint.matches === true) {
         mySwiper.querySelector(".swiper-wrapper").classList.add("swiper-desktop");
         if (mySwiper.swiper !== undefined) {
           mySwiper.swiper.destroy(true, true);
         }
         return;
       } else if (breakpoint.matches === false) {
         mySwiper.querySelector(".swiper-wrapper").classList.remove("swiper-desktop");
         return enableSwiper();
       }
    };
    
    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
  },
  
  cartUpsellInit: function(event) {
    const _this = event.target; 
    const id = _this.value; 
    const container = _this.closest(".upsell-variant");
    const items = [{"id": id, "quantity": 1}];
    
    if(_this.classList.contains("active")) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 'items': items })
      })
      .then((response) => {
        if (response.ok) { return response; }
        return response.text().then(text => {
          let errorText = JSON.parse(text).description;
          throw new Error(errorText);
        });
      })
      .then((data) => {
        console.log("response", data);
        if(document.querySelector("cart-drawer-items")) {
          document.querySelector("cart-drawer-items").dispatchEvent(new Event('cart:refresh'));
        }
        _this.classList.add("check");
        _this.selectedIndex = 0;
      })
      .catch((error) => {
        container.classList.add('error');
        container.insertAdjacentHTML("beforeend", `<span class="error-text" data-error>${ error.toString().replace("Error: ", "") }</span>`);
        _this.selectedIndex = 0;
        setTimeout(function () { 
          container.classList.remove('error');
          container.querySelector('[data-error]').remove();
        }, 2000);
      });
    }
  },
 
  videoControls: function(selector) {
    let videoContainers = document.querySelectorAll(selector);
    
    videoContainers.forEach(function(element) {
      let media = element.querySelector("video");
      let dekstopVideo = element.dataset.videoDekstop;
      let mobileVideo = element.dataset.videoMobile;
      
      let play = element.querySelector(".play--button");
      let stop = element.querySelector(".overlay--toggle");
      
      const insertVideo = (videoElement, desktop, mobile) => {
        if(!mobile) {
          if(!videoElement.src) {
            videoElement.src = desktop;
            videoElement.load();
          }
        } else {
          if ( window.innerWidth > 769 ) { videoElement.src = desktop; }
          if ( window.innerWidth <= 769 ) { videoElement.src = mobile; }
          videoElement.load();
        }
         
         videoElement.play();
      };
      
      element.querySelector("button").addEventListener('click', function(event) {
        if (!element.classList.contains("video--paused")) {
          media.pause();
          media.load();
          media.currentTime = 0;
          media.controls = false;
          element.classList.add("video--paused");
        } else {
          element.classList.remove("video--paused");
          media.controls = true;
          insertVideo(media, dekstopVideo, mobileVideo);
        }
      });

      media.onpause = function() {
        element.classList.add("video--paused");
        media.pause();
      };
      
      media.onplay = function() {
        element.classList.remove("video--paused");
        media.play();
      };
    });
  },
  
  getDistanceToParentBottom : function(element) {
    let elementRect = element.getBoundingClientRect();
    let parentRect = element.parentElement.getBoundingClientRect();
    let distanceToParentBottom = parentRect.bottom - elementRect.bottom;
    return distanceToParentBottom;
  },
  
  setElementHeight : function() {
    const elementHeight = (event) => {
      document.querySelectorAll("[data-height^='target']").forEach((el) => { 
        let container = el.closest("[data-height='container']");
        let name = el.getAttribute("data-height").split("/")[1];
        if(name) {
          document.documentElement.style.setProperty(`--${ name }`, el.clientHeight + "px");
        } else {
          container.style.setProperty('--element_height', el.clientHeight + 'px');
          if(!container.classList.contains("height-set")) {
            container.classList.add("height-set");
          }
        }
      });
    }
    window.addEventListener("resize", elementHeight);
    window.addEventListener("load", elementHeight);
  },

  setScrollAttributes: function() {  
    let lastScrollTop = 0;
    
    const handleScroll = (event) => {
      let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      this.container.setAttribute("data-scrollDirection", (currentScroll > lastScrollTop ? "down" : "up"));
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
      
      this.container.setAttribute("data-scrolled", window.scrollY > 0);
      
    };
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("load", handleScroll);
  },

  setStickyElement: function(selector) {
    const elements = document.querySelectorAll(selector);
    let distance;
    
    this.checkScrollPosition(elements, this.header.clientHeight);
    window.addEventListener("scroll", () => {
      this.checkScrollPosition(elements, this.header.clientHeight);
    });
  },

  checkScrollPosition: (elements, header) => {
    let distance;
    let elementHeight;
    
    elements.forEach(function(element) {
      distance = window.pageYOffset + element.getBoundingClientRect().top;
      distance = element.getBoundingClientRect().top - header;
      elementHeight = element.clientHeight;

      element.style.paddingTop = distance <= 0 ? `${ elementHeight }px` : 0;
      element.setAttribute("data-sticky", distance <= 0);
    });
  },

  setInputValue: function(event, callback) {
    let self = event.target;
    let container = self.parentElement;
    let input = container.querySelector("input");
    let min = parseInt(input.getAttribute("min"));
    let current = parseInt(input.value);
    let max = parseInt(input.getAttribute("max"));

    input.value = self.classList.contains("plus") ? (current < max ? current + 1 : max) : (current > min ? current - 1 : min);

    if(self.classList.contains("minus") && current === min) {
      //callback(input.value);
    }

    callback(input.value);
    
    input.dispatchEvent(new Event('input', { 'bubbles': true }));
  },

  handlelize: function(str) {
    str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/([^\w]+|\s+)/g, '-')
      .replace(/\-\-+/g, '-')
      .replace(/(^-+|-+$)/g, '')
      .toLowerCase();
  
    return str
  },
  
  getUrlParameter: function(name) {
    let queryString = window.location.search.substring(1);
    let params = queryString.split("&");
  
    for (var i = 0; i < params.length; i++) {
      var pair = params[i].split("=");
      if (pair[0] === name) {
        return decodeURIComponent(pair[1]);
      }
    }
    return null;
  },

  setCheckoutUtm: function() {
    // let checkoutForm = document.querySelector('[action$="/cart"]');
    // let utmCookie = this.getCookie("utm_cookie");

    // if(checkoutForm && utmCookie) {
    //   checkoutForm.setAttribute("action", checkoutForm.getAttribute("action").split("?")[0] + utmCookie);
    // }
  },
  
  saveUtmParams: function(selector) {
    // if(location.search.indexOf("utm_campaign") > -1 || location.search.indexOf("utm_source") > -1) {
    //   this.setCookie("utm_cookie", "?" + location.href.split("?")[1], 11);
    // }
      
    // let utmCookie = this.getCookie("utm_cookie");
    // if(utmCookie) {
    //   document.querySelectorAll(selector).forEach(function(element) {
    //       let href = element.href.split("?");
    //       if(href.length > 1) {
    //         element.href = (href[0] + utmCookie + "&" + href[1]).replace("/?", "?");
    //       } else {
    //         element.href = (element.href + utmCookie).replace("/?", "?");
    //       }
    //   });

    //   document.querySelectorAll('[href*="/pages/healthy-aging-quiz"]').forEach((element) => {
    //     let href = element.href.split("?");
    //     if(href.length > 1) {
    //       element.href = (href[0] + utmCookie + "&" + href[1]).replace("/?", "?");
    //     } else {
    //       element.href = (element.href + utmCookie).replace("/?", "?");
    //     }
    //   });
    // }
  },

  getCookie: function(cookieName) {
    let name = cookieName + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let cookieArray = decodedCookie.split(';');
  
    for (var i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i].trim();
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
  
    return null;
  },

  setCookie: function(cookieName, cookieValue, daysToExpire) {
    let expirationDate = "";
    if (daysToExpire) {
      let expirationTime = new Date();
      expirationTime.setTime(expirationTime.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
      expirationDate = "; expires=" + expirationTime.toUTCString();
    }
    document.cookie = cookieName + "=" + encodeURIComponent(cookieValue) + expirationDate + "; path=/";
  },

  fontSize: function() {
    function adjustFontSize() {
      const elements = document.querySelectorAll('[data-font]');

      elements.forEach(element => {
        const elementWidth = element.offsetWidth;
        
        const fontData = element.getAttribute('data-font').split('/');
        const baseFontSize = parseFloat(fontData[0]) || 10;
        const baseContainerWidth = parseFloat(fontData[1]) || 1280;
        
        let newFontSize = (elementWidth / baseContainerWidth) * baseFontSize;

        if(newFontSize >= 16) {
          newFontSize = 16;
        }
        element.style.fontSize = newFontSize + 'px';
      });
    }

    window.addEventListener('load', () => {
      adjustFontSize();
      setTimeout(adjustFontSize, 1500);
      // setTimeout(adjustFontSize, 2000);
      setTimeout(adjustFontSize, 3000);
    });
            
    window.addEventListener('resize', adjustFontSize);
  },

  
  initImageSizeLogging: function() {
    const breakpoints = [362, 555, 865, 989, 1198, 1498];
    const widthsCollected = new Map();
    let lastLoggedWidth = null;

    const tryLogAll = () => {
      if (widthsCollected.size === breakpoints.length) {
        const widths = breakpoints.map(bp => widthsCollected.get(bp));
        const min = Math.min(...widths);
        const max = Math.max(...widths);
        const widthsStr = widths.map(w => w.toFixed(2)).join(', ');
        console.log(`${widthsStr}, ${min.toFixed(0)}:${max.toFixed(0)}`);
      }
    };

    window.addEventListener('resize', () => {
      const width = Math.floor(window.innerWidth);
      if (breakpoints.includes(width) && width !== lastLoggedWidth) {
        lastLoggedWidth = width;
        if (window.temp1 instanceof HTMLElement) {
          const renderedWidth = window.temp1.clientWidth;
          widthsCollected.set(width, renderedWidth);
          console.log(`\n[Viewport ${width}px] temp1 rendered size: ${renderedWidth.toFixed(2)}`);
          tryLogAll();
        } else {
          console.log(`\n[Viewport ${width}px] temp1 is not set or not an element.`);
        }
      }
    });

    const initWidth = Math.floor(window.innerWidth);
    if (breakpoints.includes(initWidth) && window.temp1 instanceof HTMLElement) {
      const renderedWidth = window.temp1.clientWidth;
      widthsCollected.set(initWidth, renderedWidth);
      console.log(`\n[Viewport ${initWidth}px] temp1 rendered size: ${renderedWidth.toFixed(2)}`);
      tryLogAll();
    }
  }
};

Custom.init();

})();

class QuizElement extends HTMLElement {
  constructor() {
    super();
    this.sections = this.querySelectorAll(".element-section");
    this.currentIndex = 0;
    this.totalSteps = this.sections.length - 1;
    this.quizIndex = this.dataset.quiz;
    this.header = this.querySelector(".element-header");
    this.progressBar = this.querySelector(".element-headerProgress div");
    this.loadingOverlay = this.querySelector(".element-loading");
    this.backButton = this.querySelector(".element-headerButton button");
    this.cartButton = this.querySelector(".element-cart");
    this.stepsWrapper = this.querySelector(".element-headerSteps > span");
    this.currentStepSpan = this.querySelector("[data-current]");
    this.category = localStorage.getItem("selectedQuizId") || "";
    this.responses = JSON.parse(localStorage.getItem("quizResponses")) || {};
    this.responsesFull = JSON.parse(localStorage.getItem("quizResponsesFull")) || {};
    this.emailSectionIndex = parseInt(document.querySelector(".section-email").dataset.index);

    // alert(JSON.stringify(this.responses));
  }

  connectedCallback() {
    this.initializeQuiz();
    this.calculateInputGroups();
    this.klaviyoForm();
    
    window.addEventListener("hashchange", () => this.loadFromHash());
    this.delegateListener("change", `#checkobx-subs`, (e) => {
      let checked = e.target.checked;

      document.querySelectorAll(`[data-section="quiz_products"] .element-price`).forEach((el) => {
        let discountPrice = el.querySelector(".discounted");
        let defaultPrice = el.querySelector(".default");
        let badgeElement = el.querySelector(".element-badge");

        discountPrice.classList.toggle("hide");
        defaultPrice.classList.toggle("hide");
        badgeElement.classList.toggle("hide");
      });

      document.querySelectorAll(".sub-element").forEach((el) => {
        el.classList.toggle("hide");
      });
    });

    this.delegateListener("change", `#checkobx-bmi`, (e) => {
      const container = e.target.closest(".element-section");
      const isMetric = !e.target.checked;
      const heightInput = container.querySelector("[data-height]");
      const weightInput = container.querySelector("[data-weight]");

      const height = heightInput.value.trim();
      const weight = weightInput.value.trim();
      
      this.validateHeightWeight(height, weight, isMetric);
    });
    
    this.delegateListener("click", `[data-section="quiz_products"] button`, (e) => {
      this.productCartButton(e);
    });
  }

  initializeQuiz(index = 0) {
    this.loadFromHash(index, true);
    this.populateInputs();
    this.updateProgress();
    this.addNavigation();
    this.bmiCheckboxSetup();
  }

  loadFromHash(ind, event = false) {
    let match = window.location.pathname.match(/^\/pages\/[^/]+\/([^#/]+)/);
    let urlParams = match ? match[1] : "";
    let index = parseInt(window.location.hash.replace("#step-", ""), 10) || ind;

    // console.log("1: load", this.currentIndex, index);
    
    if (urlParams && !urlParams.includes('=')) {
      index = this.totalSteps;
    }

    if (urlParams) {
      index = this.totalSteps;
    }
    
    if (isNaN(index) || index < 0 || index > this.totalSteps) {
      index = 0;
    }

    this.toggleSection(this.currentIndex, index);
    this.currentIndex = index;
    this.updateProgress();

    if((this.emailSectionIndex - 1) === this.currentIndex) {
      this.populateFormInputs(document.querySelector(".section-email"));
    }
    
    // console.log("1.5: load", this.currentIndex, this.totalSteps);
    
    if (this.currentIndex === this.totalSteps) {
      if (!event) {
        return;
      }
      this.fetchResultsPage();
    }
  }

  collectResponses(index) {
    let inputs = this.sections[index].querySelectorAll("input[name]");
    
    inputs.forEach((input) => {
      let name = input.name;
      if (input.type === "checkbox") {
        if (!this.responses[name] || !Array.isArray(this.responses[name])) {
          this.responses[name] = [];
        }

        if ((input.type === "checkbox" && input.checked) || (input.type === "text" && input.value.trim() !== "")) {
          if (!this.responses[name].includes(input.value)) {
            this.responses[name].push(input.value);
          }
        } else {
          this.responses[name] = this.responses[name].filter(val => val !== input.value);
        }

        if (this.responses[name].length === 0) {
          delete this.responses[name];
        }
      } else if (input.type === "hidden") {
        this.responses[name] = input.value.replace(".", "_");
      
      } else if (input.type === "text") {
        if (!this.responses[name] || !Array.isArray(this.responses[name])) {
          this.responses[name] = [];
        }

        if ((input.type === "text" && input.value.trim() !== "")) {
          if (!this.responses[name].includes(input.value)) {
            this.responses[name].push(input.value);
          }
        } else {
          this.responses[name] = this.responses[name].filter(val => val !== input.value);
        }

        if (this.responses[name].length === 0) {
          delete this.responses[name];
        }
      } else if (input.type === "radio" && input.checked) {
        this.responses[name] = input.value;
      }
    });

    localStorage.setItem("quizResponses", JSON.stringify(this.responses));
  }

  populateInputs() {
    // console.log("2: inputs", this.responses);
    Object.keys(this.responses).forEach((name) => {
      let inputs = this.querySelectorAll(`[name='${name}']`);
      inputs.forEach((input, index) => {
        if (input.type === "radio") {
          input.checked = this.responses[name] === input.value;
        } else if (input.closest(`[data-type="BMI"]`)) {
          let values = this.responses[name] || [];
          input.value = values.replace("_", "'") || "";
        } else {
          let values = this.responses[name] || [];
          input.value = values[index].replace("_", ".") || "";
        }
      });
    });
  }

  getParamsFromUrl() {
    let match = window.location.pathname.match(/^\/pages\/[^/]+\/([^#/]+)/);
    let paramsString = match ? match[1] : "";
    let params = new URLSearchParams(paramsString);
    let urlResponses = {};

    for (let [key, value] of params.entries()) {
      if (value.includes("+")) {
        urlResponses[key] = value.split("+");
      } else {
        urlResponses[key] = value;
      }
    }

    return urlResponses;
  }

  toggleSection(fromIndex, toIndex) {
    console.log(this.sections[toIndex].classList);
    if(this.sections[toIndex].classList.contains("section-email") || this.sections[toIndex].classList.contains("section-results")) {
      let userQuizData = this.responsesFull
      let queryParams = new URLSearchParams();
      Object.keys(this.responses).forEach((key) => {
        let value = this.responses[key];
        queryParams.append(key, Array.isArray(value) ? value.join("+") : value);
      });

      queryParams = queryParams.toString();

      // klaviyo.identify({
      //    'Quiz URL' : "https://masi.eu/pages/longevity-quiz/" + queryParams,
      //     ...userQuizData
      // });

      console.log({
         'Quiz URL' : "https://masi.eu/pages/longevity-quiz/" + queryParams,
          ...userQuizData
      });
      
      if(this.sections[toIndex].innerText.includes("Thanks for subscribing!")) {
        location.reload();
      }
    }

    if (this.sections[fromIndex]) this.sections[fromIndex].dataset.active = "false";
    if (this.sections[toIndex]) this.sections[toIndex].dataset.active = "true";
  }

  updateProgress() {
    // console.log("3: updateProgress");
    let progress = ((this.currentIndex + 1 - 1) / (this.totalSteps + 1 - 1)) * 100;
    this.progressBar.style.width = `${progress}%`;
    this.currentStepSpan.innerHTML = `${(this.currentIndex + 1)}/${this.totalSteps}`;
    this.currentStepSpan.classList.remove("hide");
    this.backButton.classList.remove("hide");
    this.backButton.nextElementSibling.classList.add("hide");
    this.cartButton.classList.add("hide");
    this.header.classList.remove("style--results");
    document.querySelector(".element-header .custom-localization").style.display = "none";
    
    if (this.currentIndex === this.totalSteps) {
      this.backButton.classList.add("hide");
      this.cartButton.classList.remove("hide");
      this.backButton.nextElementSibling.classList.remove("hide");
      this.header.classList.add("style--results");
      this.currentStepSpan.innerHTML = `<button id="product-section" type="button" class="button-primary">SEE THE PRODUCTS</button>`;
    }

    if (this.currentIndex == 0) {
      this.backButton.classList.add("hide");
      this.currentStepSpan.classList.add("hide");
      document.querySelector(".element-header .custom-localization").style.display = "flex";
    }
  }

  addNavigation() {
    // console.log("4: addNavigation");
    const backButton = this.querySelector("[data-button='back']");
    if (backButton) {
      backButton.addEventListener("click", () => this.prevSection());
    }
        
    // console.log("4.5: addNavigation", this.sections);
    this.sections.forEach((section, index) => {
      if (section.classList.contains("section-results") || section.classList.contains("section-dashboards")) return;

      if (section.querySelector(`[data-type="Single Option"]`)) {
        section.querySelectorAll(`[data-type="Single Option"] input`).forEach((el) => {
          el.addEventListener("click", (e) => {
            this.nextSection(index);
          });
        });
        return;
      }

      let nextButton = section.querySelector(".next-button");
      if (!nextButton) {
        nextButton = document.createElement("button");
        nextButton.classList.add("next-button", "button-primary");
        nextButton.textContent = "Next";
        nextButton.addEventListener("click", () => this.nextSection(index));
        section.querySelector(".section--inner .element-button").appendChild(nextButton);
      } else {
        // alert(["button: ", nextButton.textContent]);
        // console.log(["button: ", nextButton.textContent]);
        nextButton.addEventListener("click", () => this.nextSection(index));
      }
    });

    this.delegateListener("click", `[data-section="quiz_hero"] button`, () => {
      this.querySelector(`[data-section="quiz_blocks"]`).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    });
    
    this.delegateListener("click", `#product-section`, () => {
      // this.querySelector(`[data-section="quiz_products"]`).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      const quizSection = this.querySelector(`[data-section="quiz_products"]`);
      const header = this.querySelector(`[data-section="quiz-element"] > header`);
      
        const headerHeight = header ? header.offsetHeight : 0;
        const sectionTop = quizSection.getBoundingClientRect().top + window.scrollY;
        
        window.scrollTo({
          top: sectionTop - headerHeight,
          behavior: "smooth",
        });
    });
    
    this.delegateListener("click", `.element-cart`, () => {
      document.querySelector("#cart-icon-bubble").click()
    });
  }

  populateFormInputs(section) {
    const quizResponses = JSON.parse(localStorage.getItem("quizResponses")) || {};
    const inputs = section.querySelectorAll("input[type='email']");
    
    inputs.forEach((input) => {
        const name = input.placeholder.replaceAll(" ", "_").toLowerCase();
        if (quizResponses[name]) {
          input.value = quizResponses[name];
          const event = new Event("input", { bubbles: true });
          input.dispatchEvent(event);
        }
    });
  }
  
  nextSection(index) {
        // console.log("nextSection: ", index, this.currentIndex + 1);
    this.collectResponses(index);
    this.collectResponsesFull(index);

    if (this.currentIndex < this.totalSteps - 1) {
      this.updateHash(this.currentIndex + 1);
    } else if (this.currentIndex === this.totalSteps - 1) {
      this.fetchResultsPage(() => this.updateHash(this.currentIndex + 1));
    }
  }

  prevSection() {
    if (this.currentIndex > 0) {
      this.updateHash(this.currentIndex - 1);
    } else {
      window.location.replace(window.location.origin);
    }
  }

  updateHash(index) {
    window.location.hash = `#step-${index}`;
  }

  fetchResultsPage(callback) {
    let queryParams = new URLSearchParams();
    let urlResponses = this.getParamsFromUrl();

    this.backButton.dataset.hidden = Object.keys(urlResponses).length !== 0;
    // this.stepsWrapper.dataset.hidden = Object.keys(urlResponses).length !== 0;

    let storedResponses = JSON.parse(localStorage.getItem("quizResponses")) || {};
    this.responses = Object.keys(urlResponses).length > 0 ? urlResponses : storedResponses;

    if(this.responses["quiz"] != this.quizIndex) {
      localStorage.removeItem("quizResponses");
      localStorage.removeItem("quizResponsesFull");
      window.location.replace(location.href.match(/^https?:\/\/[^\/]+\/[^\/]+\/[^\/]+/)[0]);
      return;
    }
    
    Object.keys(this.responses).forEach((key) => {
      let value = this.responses[key];
      queryParams.append(key, Array.isArray(value) ? value.join("+") : value);
    });

    document.body.style.overflow = "hidden";

    this.loadingOverlay.classList.remove("hide");

    
    fetch(`${ (location.origin + window.Shopify.routes.root) }pages/results/${queryParams.toString()}`)
      .then(response => response.text())
      .then(html => {
        let resultsContainer = this.querySelector("[data-results]");
        if (resultsContainer) resultsContainer.innerHTML = html;
        if (callback) callback();
        setTimeout(() => {
          this.loadingOverlay.classList.add("hide");
          document.body.style.overflow = "visible";

        }, 2500);
        this.initResultsSections();
      })
      .catch(error => console.error("Error fetching results:", error));
  }
  
  initResultsSections(index) {
    document.querySelectorAll(`[data-section="quiz_blocks"] .grid--wrapper`).forEach((el) => {
      if(el.classList.contains("combined-section")) {
        // let nextSection = el.nextElementSibling;
        let elOrder = parseInt(el.style.order) + 1;
        let nextSection = document.querySelector(`.element-sections > div[style*="order: ${ elOrder };"]`);
        el.querySelector(".element-combined").textContent = nextSection.querySelector(".text--wrapper").textContent;
        nextSection.classList.add("hide");
      }
    });
    
    window.Custom.initCollapsable();
    setTimeout(() => {
      const swiper = new Swiper(`[data-section="static_reviews"] .swiper`, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        centeredSlides: true,
        
        pagination: {
          el: `[data-section="static_reviews"] .swiper-pagination`,
          clickable: true
        },
        navigation: {
        nextEl: '.next',
        prevEl: '.prev',
        },
        breakpoints: {
          868: {
            slidesPerView: 3,
            spaceBetween: 20,
            centeredSlides: false
          },
          1360: {
            slidesPerView: 3,
            spaceBetween: 40
          }
        }
      });
    }, 1000);
  }



  
  collectResponsesFull(index) {
    let inputs = this.sections[index].querySelectorAll("input[name]");

    inputs.forEach((input) => {
      if(input.closest(".section-email")) {
        return;
      }
      
      let name = input.closest(".element-section").querySelector("h2.heading").textContent.trim();
      if (input.type === "radio" && input.checked) {
        this.responsesFull[name] = input.nextElementSibling.textContent.trim();
      } else if (input.classList.contains("input-bmi")) {
        let splitValue = input.value.split("--")
        this.responsesFull["Height"] = splitValue[0];
        this.responsesFull["Weight"] = splitValue[1];
      }
    });

    localStorage.setItem("quizResponsesFull", JSON.stringify(this.responsesFull));
  }
  
  calculateInputGroups() {
    document.querySelectorAll(".input--group").forEach(group => {
      const hiddenInput = group.querySelector("input[type='hidden']");
      const textInputs = group.querySelectorAll("input[type='text']");
  
      function updateHiddenInput() {
        let values = Array.from(textInputs).map(input => input.value.trim());
  
        values = values.map(value => {
          if (/^\d+'$/.test(value)) {
            return value + "0";
          }    
          
          if(value.indexOf("'") > -1 || value.indexOf('"') > -1 ) {
            let sanitizedValue = value.replace(/^(\d+)"(\d{1,2})"?$/, "$1'$2\"");
            return sanitizedValue;
          }
          
          return value;
        });

        hiddenInput.value = values.join("--");
        hiddenInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
  
      textInputs.forEach(input => input.addEventListener("input", updateHiddenInput));
    });
  }
  
  bmiCheckboxSetup() {
    const checkbox = this.querySelector("#checkobx-bmi");
    if (!checkbox) return;

    const container = checkbox.closest(".element-section");
    const nextButton = container.querySelector(".next-button");
    nextButton.setAttribute("disabled", true); // Disable Next button initially

    const optionId = "option_" + checkbox.closest(".element-section").dataset.index;
    const storageValues = this.responses[optionId] || "";

    const heightInput = this.querySelector("[data-height]");
    const weightInput = this.querySelector("[data-weight]");
    const errorContainer = document.createElement("div");

    const groupContainer = this.querySelector(".input--group");
    errorContainer.style.color = "#fff";
    errorContainer.style.fontSize = "14px";
    errorContainer.style.marginTop = "5px";
    groupContainer.appendChild(errorContainer);
  
    const showError = (message) => {
      errorContainer.textContent = message;
    };

    const clearError = () => {
      errorContainer.textContent = "";
      heightInput.style.border = "";
      weightInput.style.border = "";
    };
  
    const updatePlaceholders = () => {
      if (checkbox.checked) {
        heightInput.placeholder = "FT'IN";
        weightInput.placeholder = "LBS";
      } else {
        heightInput.placeholder = "CM";
        weightInput.placeholder = "KG";
      }
    };
  
    const populateInputs = () => {
      if (!storageValues.includes("--")) return;

      const [heightValue, weightValue] = storageValues.split("--");

      if (heightValue && weightValue) {
        heightInput.value = heightValue.replace("_", "'");
        weightInput.value = weightValue;
        checkbox.checked = this.isImperial(heightValue, weightValue);
        updatePlaceholders();
      }
    };
  
    const validateInputs = () => {
      const height = heightInput.value.trim();
      const weight = weightInput.value.trim();
      const isMetric = !checkbox.checked;

      nextButton.setAttribute("disabled", true);

      if (!height || !weight) {
        showError("Both height and weight are required.");
        return false;
      }

      const errorMessage = this.validateHeightWeight(height, weight, isMetric);

      clearError();
      if (errorMessage) {
        showError(errorMessage);
        if (errorMessage.includes("Height")) {
          heightInput.style.border = "1px solid red";
        }
        if (errorMessage.includes("Weight")) {
          weightInput.style.border = "1px solid red";
        }
        return false;
      }
      nextButton.removeAttribute("disabled");
      return true;
    };
  
    checkbox.addEventListener("change", updatePlaceholders);
    heightInput.addEventListener("input", validateInputs);
    weightInput.addEventListener("input", validateInputs);

    populateInputs();
    updatePlaceholders();
    validateInputs();
  }

  isImperial(height, weight) {
    return height.includes("'") || parseFloat(weight) > 300;
  }

  validateHeightWeight(height, weight, isMetric) {
    if (!height || !weight) {
      return "Both height and weight must be filled.";
    }

    console.log(height, weight, isMetric);
    
    if (isMetric) {
      if (!/^\d+(\.\d+)?$/.test(height) || !/^\d+(\.\d+)?$/.test(weight)) {
        return "Metric values must be numbers only.";
      }
      if (parseFloat(height) < 50 || parseFloat(height) > 300) {
        return "Height must be between 50 and 300 cm.";
      }
      if (parseFloat(weight) < 10 || parseFloat(weight) > 500) {
        return "Weight must be between 10 and 500 kg.";
      }
    } else {
      // if (!/^\d+'(\d{1,2})?$/.test(height)) {
      //   return "Imperial height must be in feet and inches format (e.g., 5'9\").";
      // }

      // const [feet, inches] = height.split("'").map(num => parseInt(num.replace('"', '')));
      // if (feet < 4 || feet > 8 || (inches !== undefined && (inches < 0 || inches > 11))) {
      //   return "Height must be between 4'0\" and 8'0\".";
      // }

      // if (parseFloat(weight) < 22 || parseFloat(weight) > 1100) {
      //   return "Weight must be between 22 and 1100 lbs.";
      // }

      
      let sanitizedHeight = height.trim().replace(/^(\d+)"(\d{1,2})"?$/, "$1'$2\"");
      
      if (!/^\d+'\d{1,2}"?$/.test(sanitizedHeight)) {
        return "Imperial height must be in feet and inches format (e.g., 5'9\").";
      }
      
      const [feet, inches] = sanitizedHeight
        .split("'")
        .map(num => parseInt(num.replace('"', '').trim(), 10));
      
      if (
        isNaN(feet) || feet < 4 || feet > 8 ||
        isNaN(inches) || inches < 0 || inches > 11
      ) {
        return "Height must be between 4'0\" and 8'11\".";
      }
      
      const weightNum = parseFloat(weight);
      if (isNaN(weightNum) || weightNum < 22 || weightNum > 1100) {
        return "Weight must be between 22 and 1100 lbs.";
      }
    }

    
    return null;
  }
  
  klaviyoForm() {
      const _this = this;
    // const formContainer = document.querySelector(".section-email .klaviyo-form-QYqhcp");
    // const nextButton = document.querySelector(".section-email .element-button .next-button");
    
    // if (formContainer && nextButton) {
    //   nextButton.style.display = "none";
    //   const observer = new MutationObserver((mutations, obs) => {
    //     mutations.forEach((mutation) => {
    //       if (mutation.type === "childList") {
    //         const successMessage = formContainer.querySelector("h1");
    //         if (successMessage && successMessage.innerText.includes("Thanks for subscribing!") && nextButton.style.display != "block") {
    //             nextButton.style.display = "block";
    //           console.log("run");
    //           this.nextSection(formContainer.closest(".section-email").dataset.index);
    //           obs.disconnect();
    //         }
    //       }
    //     });
    //   });
    //   observer.observe(formContainer, { childList: true, subtree: true });
    // }

    
    function waitForHost() {
      const formContainer = document.querySelector(".section-email");
      const nextButton = document.querySelector(".section-email .element-button .next-button");
      const host = document.querySelector('.section-email #app-embed');

      
      nextButton.style.display = "none";
      if (host && host.shadowRoot) {
        console.log('Host found:', host, host.shadowRoot);
        const shadow = host.shadowRoot;
        const observer = new MutationObserver((mutations) => {
          for (const mutation of mutations) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-current-step') {
              nextButton.style.display = "block";
              _this.nextSection(formContainer.dataset.index);
            }
          }
        });

        observer.observe(shadow, {
          childList: true,
          subtree: true,
          attributes: true,
          characterData: true
        });
        console.log('Observer attached to host');
      } else {
        // Check again after 200ms if not found
        setTimeout(waitForHost, 200);
      }
    }

    waitForHost();
  }

  cartAdd(formData, _this) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((response) => response.json())
    .then(response => {
      fetch(window.Shopify.routes.root + "?sections=cart-drawer")
        .then((response) => response.json())
        .then((response) => {
          let selector = "#CartDrawer";
          let drawer = document.querySelector(selector)
          drawer.innerHTML = new DOMParser().parseFromString(response["cart-drawer"], 'text/html').querySelector(selector).innerHTML;
  
          window.Custom.initSlider(`.drawer__upsell .swiper`);
          window.Custom.cartUpsellAuto();
          window.Custom.setCheckoutUtm();
          
          if(document.querySelector("cart-drawer-items")) {
            document.querySelector("cart-drawer-items").dispatchEvent(new Event('cart:refresh'));
          }
          
          document.querySelector('#cart-icon-bubble').click();
          document.querySelector(".element-headerSteps .cart-count-bubble").classList.remove("hide");
          _this.classList.remove("button--loading");
        });
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  
  productCartButton(event) {
    let subscriptionCheckbox = document.querySelector(`[data-section="quiz_products"] #checkobx-subs`).checked;
    let _this = event.target; 
    let container = _this.closest(".element-products");
    let id = _this.dataset.id; 
    let plan = _this.dataset.plan; 
    let productPrice = _this.dataset.price; 
    let items = {"id": id, "quantity": 1};
    let formData = {'items': [], "sections": "cart-data"};

    if(plan && !subscriptionCheckbox) {
      productPrice = _this.dataset.subscriptionPrice; 
      items.selling_plan = plan;
      if(container.dataset.cartMessage || container.dataset.checkoutMessage) {
        items.properties = {};
      }
      
      if(container.dataset.cartMessage) {
        items.properties[window.theme.cart_message] = container.dataset.cartMessage;
      }
      
      if(container.dataset.checkoutMessage) {
        items.properties[window.theme.checkout_message] = container.dataset.checkoutMessage;
      }
    }

    formData.items.push(items);
    // this.cartAdd(formData);
    
    // alert(JSON.stringify(formData));
    let europa = [
      "AL", "AD", "AT", "BY", "BE", "BA", "BG", "HR", "CY", "CZ",
      "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IS", "IE", "IT",
      "XK", "LV", "LI", "LT", "LU", "MT", "MD", "MC", "ME", "NL",
      "MK", "NO", "PL", "PT", "RO", "RU", "SM", "RS", "SK", "SI",
      "ES", "SE", "UA", "GB", "VA"
    ];
    _this.classList.add("button--loading");
    if((europa.indexOf(window.theme.location) === -1 && window.theme.usa_thresshold > 0) || (window.theme.location == "CH" && window.theme.ch_thresshold > 0)) {
      fetch('/cart.js', { method: 'GET', headers: {'Content-Type': 'application/json;'}})
      .then((response) => {
        return response.json();
      }).then((cartObject) => {
        const total = cartObject.total_price;
        let threshold = window.theme.usa_thresshold * Number(Shopify.currency.rate);
        let threshold_text = window.theme.usa_thresshold_error;
        if(window.theme.location === "CH" && window.theme.ch_thresshold > 0) {
          threshold = window.theme.ch_thresshold * Number(Shopify.currency.rate);
          threshold_text = window.theme.ch_thresshold_error;
        }

        document.querySelector("[data-cart_popup]").closest("[data-popup-wrapper]").querySelector(".text--wrapper").textContent = threshold_text;
        window.theme.cart_total = cartObject.total_price;
        
        const rate = Number(Shopify.currency.rate);
        const totalNormal = cartObject.items.reduce((sum, currentValue) => {
          if (currentValue.variant_title === "12-Month Supply") {
            return sum;
          } else {
            return sum + currentValue.line_price;
          }
        }, 0);

        if((totalNormal + productPrice * 1) > threshold) {
          document.querySelector("[data-cart_popup]").click();
          _this.classList.remove("button--loading");
          return;
        }
        
        this.cartAdd(formData, _this);
        
      }).catch(() => { });
    } else {
      this.cartAdd(formData, _this);
    }
  }
}

customElements.define("quiz-element", QuizElement);

